(() => {
  const page = document.querySelector('[data-dityy-campaign]');
  if (!page) return;

  const cards = [...page.querySelectorAll('.product[data-key]')];
  for (const group of ['c8', 'botanical', 'pantry']) {
    const thumbs = page.querySelector(`[data-thumbs="${group}"]`);
    cards.filter(card => card.dataset.group === group).slice(0, 2).forEach(card => {
      const source = card.querySelector('.image img');
      if (!source) return;
      const image = source.cloneNode(true);
      image.alt = '';
      thumbs.append(image);
    });
  }

  const focus = new URLSearchParams(location.search).get('focus');
  const active = cards.find(card => card.dataset.key === focus) || cards[0];
  const spotlight = page.querySelector('[data-spotlight]');
  if (active && spotlight) {
    const copy = document.createElement('div');
    copy.className = 'copy purchase-box';
    copy.dataset.selectedVariant = active.dataset.selectedVariant;

    const tag = document.createElement('span');
    tag.className = 'tag';
    tag.textContent = 'ده المنتج اللي شفته';
    const title = document.createElement('h2');
    title.textContent = active.querySelector('h3').textContent;
    const description = document.createElement('p');
    description.textContent = 'اختار الحجم المناسب وشوف سعره هنا، ولو حابب قارن باقي الاختيارات اللي تحت.';
    copy.append(tag, title, description);

    const picker = active.querySelector('.size-picker');
    if (picker) copy.append(picker.cloneNode(true));
    copy.append(active.querySelector('.current-price').cloneNode(true));

    const actions = active.querySelector('.actions').cloneNode(true);
    actions.className = 'purchase-actions';
    actions.querySelector('a').textContent = 'تفاصيل المنتج';
    copy.append(actions);

    const photo = document.createElement('div');
    photo.className = 'photo';
    const image = active.querySelector('.image img');
    if (image) {
      const clone = image.cloneNode(true);
      clone.loading = 'eager';
      photo.append(clone);
    }
    spotlight.append(copy, photo);
  }

  let noticeTimer;
  function notify(message, success) {
    page.querySelector('.cart-notice')?.remove();
    const notice = document.createElement('div');
    notice.className = 'cart-notice';
    notice.textContent = message;
    if (success) {
      const link = document.createElement('a');
      link.href = (window.Shopify?.routes?.root || '/') + 'cart';
      link.textContent = 'شوف السلة ←';
      notice.append(' ', link);
    }
    page.append(notice);
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => notice.remove(), 5000);
  }

  page.addEventListener('click', async event => {
    const option = event.target.closest('.size-option');
    if (option) {
      const box = option.closest('.purchase-box');
      box.dataset.selectedVariant = option.dataset.variantId;
      box.querySelector('.current-price').textContent = option.dataset.priceLabel;
      box.querySelectorAll('.size-option').forEach(item => {
        item.setAttribute('aria-pressed', String(item === option));
      });
      return;
    }

    const button = event.target.closest('.add-to-cart');
    if (!button) return;
    const variantId = button.closest('.purchase-box').dataset.selectedVariant;
    if (!/^\d+$/.test(variantId)) return;
    const previous = button.textContent;
    button.disabled = true;
    button.textContent = 'بنضيفه للسلة…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
      if (!response.ok) throw new Error('Cart add failed');
      notify('اتضاف للسلة ✓', true);
    } catch {
      notify('حصلت مشكلة. جرّب تاني بعد لحظة.', false);
    } finally {
      button.disabled = false;
      button.textContent = previous;
    }
  });
})();
